import React, { FC } from "react";
import { Fade } from "react-awesome-reveal";
import classNames from "classnames";
import { DEFAULT_FADE_DURATION } from "@app/constants";
import { LinkButtonAdapter } from "../link-button-adapter/LinkButtonAdapter";
import { Button } from "../../models";

type Props = {
  title: string;
  button: Button[];
};

export const DownloadFile: FC<Props> = ({ title, button }) => (
  <div
    className={classNames(
      "w-full px-5",
      "lg:px-16",
      "xl:px-24",
      "xxl:mx-auto xxl:max-w-container xxl:px-0",
    )}
  >
    <Fade duration={DEFAULT_FADE_DURATION} triggerOnce>
      <div
        className={classNames(
          "mt-20 flex flex-col gap-5 rounded-lg rounded-sm bg-primary p-10",
          "md:flex-row md:items-center md:justify-between md:gap-10 md:rounded-lg md:px-10",
          "lg:mt-25",
          "xl:mt-40 xl:gap-15 xl:px-11",
          "xxl:mx-auto xxl:w-2/3",
        )}
      >
        <h5
          className={classNames(
            "text-regular text-primary-content",
            "lg:text-medium",
            "xl:text-medium",
          )}
        >
          {title}
        </h5>
        <LinkButtonAdapter data={button[0]} />
      </div>
    </Fade>
  </div>
);
